export const DEFAULT_TIME_INTERVAL = 15;

export const TIME_FORMAT = 'HH:mm';
